import ProductBookContent from "./product-book-content";

export default ProductBookContent;